/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-15 00:00:00
 *
 *******************************************************/
// @flow
//
import React, { Component } from 'react';
import { Modal, TextContainer, Heading } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import FilterIcon from 'src/assets/images/subscription/filter.svg';
import SearchIcon from 'src/assets/images/subscription/search.svg';
import AnalyticsIcon from 'src/assets/images/subscription/analytics.svg';

type Props = {
  active: boolean,
  handleChange: Function
};

type ComposedProps = Props & WithI18nProps;

class PasswordProtectedOfferExpiredModal extends Component<ComposedProps, State> {
  render() {
    const { i18n, active, handleChange } = this.props;

    return (
      <Modal
        large
        open={active}
        onClose={handleChange}
        title={i18n.translate('AdminHTML.SubscriptionV3.PasswordProtectedOfferExpired.title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.subscribeNow'),
          onAction: handleChange
        }}>
        <Modal.Section>
          <TextContainer>
            <p>
              {i18n.translate('AdminHTML.SubscriptionV3.PasswordProtectedOfferExpired.content1')}
            </p>
            <p style={{ marginTop: '1px' }}>
              {i18n.translate('AdminHTML.SubscriptionV3.ExpiredModal.content2')}
            </p>
            <div className="align-center section-title">
              <Heading>
                {i18n.translate('AdminHTML.SubscriptionV3.ExpiredModal.whatMissing')}
              </Heading>
            </div>
            <div>
              <ul className="four-cols">
                <li>
                  <img className="expired-modal-icon" src={FilterIcon} alt="" />
                  <p>{i18n.translate('AdminHTML.SubscriptionV3.ExpiredModal.missing_Filter')}</p>
                </li>
                <li>
                  <img className="expired-modal-icon" src={SearchIcon} alt="" />
                  <p> {i18n.translate('AdminHTML.SubscriptionV3.ExpiredModal.missing_Search')}</p>
                </li>
                <li>
                  <img className="expired-modal-icon" src={AnalyticsIcon} alt="" />
                  <p>
                    {' '}
                    {i18n.translate('AdminHTML.SubscriptionV3.ExpiredModal.missing_Analytics')}
                  </p>
                </li>
              </ul>
            </div>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(PasswordProtectedOfferExpiredModal);
